import { IFilterComponentProps } from 'components/Table/TableFilter/types'
import { TextField } from '@mui/material'
import { inputStyles } from '../Inputs.style'

function StringFilterInput({
  value,
  columnId,
  handleFilterState,
  startAdornment,
}: IFilterComponentProps) {
  const inputValue = value === undefined || value === null ? '' : value

  return (
    <TextField
      fullWidth
      value={inputValue}
      onChange={(e) => handleFilterState(columnId, null, e?.target?.value)}
      variant="standard"
      InputProps={{ startAdornment: startAdornment }}
      sx={inputStyles}
    />
  )
}

export default StringFilterInput
